<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>PCS 02 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>Interface Name</label>
          <b-form-input
            :formatter="capitalizeAll"
            disabled
            id="interfaceName"
            name="interfaceName"
            v-model="interfaceName"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <label>SB Number (7005705)</label>
          <b-form-input
            :formatter="capitalizeAll"
            id="sbNumber"
            name="sbNumber"
            v-model="sbNumber"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <b-button
            v-if="sbNumber && interfaceName"
            @click="getAllPCS02Func()"
            size="sm"
            variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
            >Fetch</b-button
          >
        </b-col>
      </b-row>
      <hr />
      <div
        v-if="
          !getAllPcs02 ||
          getAllPcs02.response.length <= 0 ||
          getAllPcs02.responseStatus === 'not found'
        "
      >
        <b class="text-danger">No data found.</b>
      </div>
      <div v-else>
        <b-row>
          <b-col md="3" class="mt-1 mb-1">
            <strong class="text-success"
              >Response Status: {{ getAllPcs02.responseStatus }}</strong
            >
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Gross Quantity:</strong>
            {{ getAllPcs02.response[0].grossQuantity }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>SB No:</strong> {{ getAllPcs02.response[0].sbNo }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1"
            ><strong>Nature of Cargo:</strong>
            {{ getAllPcs02.response[0].natureOfCargo }}</b-col
          >
          <b-col md="3" class="mt-1 mb-1"
            ><strong>Port of Origin:</strong>
            {{ getAllPcs02.response[0].portOfOrigin }}</b-col
          >
          <b-col md="3" class="mt-1 mb-1"
            ><strong>Port of Destination:</strong>
            {{ getAllPcs02.response[0].portOfDestination }}</b-col
          >
          <b-col md="3" class="mt-1 mb-1">
            <strong>Unit of Quantity:</strong>
            {{ getAllPcs02.response[0].unitOfQuantity }}</b-col
          >
          <b-col md="3" class="mt-1 mb-1"
            ><strong>Total No of Packages:</strong>
            {{ getAllPcs02.response[0].totalNoOfPackages }}</b-col
          >
          <b-col md="3" class="mt-1 mb-1"
            ><strong>CHA Code:</strong> {{ getAllPcs02.response[0].chaCode }}</b-col
          >
          <b-col md="3" class="mt-1 mb-1"
            ><strong>SB Date:</strong> {{ getAllPcs02.response[0].sbDate }}</b-col
          >
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection";
export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllPCS02Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      interfaceName: "CHPOE05",
      sbNumber: "",
      getAllPcs02: null,
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  methods: {
    async getAllPCS02Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllPcs02 = null;

      if (this.interfaceName && this.sbNumber) {
        payload = {
          itemCode: "PCS02",
          funcUrl: "PCS/02",
          interfaceName: this.interfaceName,
          sbNumber: this.sbNumber,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              console.log("getAllPcs02 PS =>", data.getAllPcs02.response.response);
              if (
                data.getAllPcs02.response.response &&
                data.getAllPcs02.response.response.length > 0
              ) {
                this.getAllPcs02 = data.getAllPcs02.response.response[0];
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllPcs02 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// PCS02_ResponseDisplay.vue?7b8c8eea